export interface AvatarColorOption {
  value: string;
  label: string;
  unlocked: boolean;
}

export interface AvatarShellOption {
  value: number; // 1, 2, 3, 4
  label: string;
  elementN: number;
  unlocked: boolean;
}

export interface AvatarAccessoryOption {
  value: string;
  label: string;
  unlocked: boolean;
}

export const AVATAR_COLORS: AvatarColorOption[] = [
  { value: "#60A5FA", label: "Scico Blue", unlocked: true },
  { value: "#A78BFA", label: "Cosmic Purple", unlocked: true },
  { value: "#F472B6", label: "Nebula Pink", unlocked: true },
  { value: "#F59E0B", label: "Stellar Amber", unlocked: true },
  { value: "#10B981", label: "Aurora Emerald", unlocked: true },
  { value: "#EF4444", label: "Supernova Red", unlocked: true },
];

export const AVATAR_SHELLS: AvatarShellOption[] = [
  { value: 1, label: "1 Shell (Helium)", elementN: 2, unlocked: true },
  { value: 2, label: "2 Shells (Carbon)", elementN: 6, unlocked: true },
  { value: 3, label: "3 Shells (Magnesium)", elementN: 12, unlocked: true },
  { value: 4, label: "4 Shells (Calcium)", elementN: 20, unlocked: true },
];

export const AVATAR_ACCESSORIES: AvatarAccessoryOption[] = [
  { value: "None", label: "No Accessory", unlocked: true },
  { value: "glasses", label: "Lab Glasses", unlocked: true },
  { value: "hat", label: "Scientist Hat", unlocked: true },
  { value: "crown", label: "Cosmic Crown", unlocked: true },
  { value: "lab", label: "Lab Coat", unlocked: true },
  { value: "headphones", label: "Quantum Headphones", unlocked: true },
  { value: "star", label: "Superstar", unlocked: true },
  { value: "lightning", label: "Storm Bolt", unlocked: true },
];

export const AVATAR_OPTIONS = {
  colors: AVATAR_COLORS,
  shells: AVATAR_SHELLS,
  accessories: AVATAR_ACCESSORIES,
};
